module.exports = __webpack_public_path__ + "img/tournament.b4100e67.png";